import { observer } from 'mobx-react';
import { MeetingCoPilotVM } from './meeting-co-pilot.viewmodal';
import DefaultButton from '../../../../../global/default-button/default-button';
import { CONTINUE_BUTTON_TEXT } from './meeting-co-pilot.texts';
import { DefaultCloseModalButton } from '../../../../../global/modal/common/common-close-modal-buttons';
import * as React from 'react';
import { useIntl } from 'react-intl';

interface IProps {
    vm: MeetingCoPilotVM;
}
export const MeetingCoPilotModalFooter = observer(({ vm }: IProps): JSX.Element => {
    const intl = useIntl();

    const startMeetingGeneration = (): void => {
        if (vm.isCoPilotMessageEmpty()) {
            vm.allowToShowValidationError();
            return;
        }
        vm.startMeetingsGeneration();
    };

    const isContinueButtonDisabled = (): boolean => {
        return vm.isLoading || vm.showValidationError() || !!vm.getTooLongCoPilotMessageError();
    };

    const createMeetingsButtonText = `Create ${vm.generatedMeetings.length} meeting${vm.generatedMeetings.length > 1 ? 's' : ''}`;
    const isCreateMeetingsButtonDisabled = vm.generatedMeetings.length === 0;

    return (
        !vm.isMeetingsDataGenerated
            ? <div className='buttons-block buttons-block--from-right'>
                <DefaultButton
                    text={intl.formatMessage(CONTINUE_BUTTON_TEXT)}
                    modifier={['fat', 'confirm-safe']}
                    onClick={startMeetingGeneration}
                    disabled={isContinueButtonDisabled()}
                />
                <DefaultCloseModalButton />
            </div>
            : <div className='buttons-block buttons-block--space-between'>
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={createMeetingsButtonText}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.saveGeneratedMeetings}
                        disabled={isCreateMeetingsButtonDisabled}
                    />
                    <DefaultCloseModalButton />
                </div>
                {/* [OEP-14168] - temporary hidden
                 <DefaultButton
                 text={intl.formatMessage(EDIT_DETAILS_MANUALLY)}
                 modifier='options-fat'
                 onClick={vm.hideAndResetMeetingCoPilotForm}
                 />*/}
            </div>
    );
});